/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

class GenericObjectViewer extends React.Component
{

  constructor(props)
  {
    super();

    this.state =
    {
      url: props.url
    }

    this.closeModal = this.closeModal.bind(this);
  }

  closeModal()
  {
    this.props.onClose();
  }

  render()
  {
    return(
      <div onClick={this.closeModal} style={{paddingTop: "10px"}} >  
        <object height={'90%'} width={'90%'} style={{background: 'white', minHeight: "90vh"}} data={this.state.url}>AsterionDB Generic Viewer</object>
      </div>
    );
  }  
}

export default GenericObjectViewer